import React from 'react';
import { sendEvent } from '../../utils/gtag';

const supportPoints = [
  'Access expert support whenever you need it via live chat and email.',
  'Our specialists are fluent in 4+ languages so you can be sure communication will be smooth.',
  'Spend less time waiting, our speedy support team typically responds in under 2 minutes.',
  'Get personalized help from a team dedicated to your success.',
];

const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const ChatIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.745A9.863 9.863 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
    </svg>
);

const SupportSection = () => {
  return (
    <section className="py-20 bg-gradient-to-tr from-white to-[#e0f2f1]">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column */}
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-6">We are here to support you 24/7</h2>
            <div className="space-y-4">
              {supportPoints.map((point, index) => (
                <div key={index} className="flex items-start">
                  <CheckIcon />
                  <p className="ml-3 text-gray-600">{point}</p>
                </div>
              ))}
            </div>
            <button 
                onClick={() => { sendEvent('contact_us_click'); window.open('https://wa.me/+8801927046394', '_blank'); }} 
                className="mt-8 flex items-center justify-center bg-[#25D366] hover:bg-[#128C7E] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300 shadow-lg">
                <ChatIcon />
                Chat Now
            </button>
          </div>

          {/* Right Column */}
          <div>
            <img src="/img/tech support.jpg" alt="Tech Support Team" className="rounded-lg shadow-lg w-full h-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportSection;